import React, { useEffect, useState } from 'react'
import { T, TraksConsumer } from '../traks'
import { Loading } from './Loading'
import { AlertModal } from './Modals'
import { APIGet } from '../API'
import { RenderIf } from '../helpers/RenderIf'
import { cleanLogs } from '../helpers/cleanLogs'
import { DateTimeFromMiliSeconds } from '../helpers/timeFormats'

const ActionText = ({ log, ...props }) => {
	const ActionTraks = ({ action }) => {
		switch (action) {
			case "added_comment":
				return <T>added a comment</T>
			case "sent_message":
				return <T>sent a message</T>
			case "accessed_whistle":
				return <T>accessed entry</T>
			case "deleted_whistle":
				return <T>deleted entry</T>
			case "shared_whistle":
				return <T>shared entry</T>
			case "assigned_whistle":
				return <T>assigned whistle</T>
			case "changed_status":
				return <T>changed entry status</T>
			case "delete_access":
				return <T>deleted entry access</T>
			case "created_whistle":
				return <T>created entry</T>
			case "deleted_file":
				return <T>deleted file</T>
			case "requested_file_upload":
				return <T>requested file upload</T>
			case "uploaded_files":
				return <T>uploaded files</T>
			default:
				return action
		}
	}
	const withText = props.render_static(<T>with</T>)
	const toText = props.render_static(<T>to</T>)
	const agentText = log.entry.agent === "whistle_owner" ? props.render_static(<T>case reporter</T>) : log.entry.agent

	return (
		<div className="d-flex">
			{agentText + " "}
			<ActionTraks action={log.entry.action} />
			<RenderIf condition={log.entry.recipient}>
				<RenderIf condition={log.entry.action === "assigned_whistle"}>
					{" " + toText + " " + log.entry.recipient}
				</RenderIf>
				<RenderIf condition={log.entry.action !== "assigned_whistle"}>
					{" " + withText + " " + log.entry.recipient}
				</RenderIf>
			</RenderIf>
		</div>
	)
}

export const getLastLog = (whistle, getTs = false) => {
	const { actions, messages, comments } = whistle
	const allActions = [...actions, ...messages, ...comments].sort((a, b) => a.ts - b.ts)
	const lastLog = allActions.pop()
	if (getTs)
		return lastLog.ts
	const actionText = <TraksConsumer><ActionText log={lastLog} /></TraksConsumer>

	return actionText
}


const Log = ({ log }) => {
	const { ts, comment } = log
	const timeStamp = DateTimeFromMiliSeconds(ts)

	return (
		<div className="overflow-auto">
			<div className="d-flex flex-row py-2 px-3 sibilus_border">
				<div className="py-1 col">{timeStamp}</div>
				<div className="py-1 col">
					<TraksConsumer>
						<ActionText log={log} />
					</TraksConsumer>
				</div>
				<div className="py-1 col">{comment}</div>
			</div>
		</div>
	)
}

const Logs = ({ whistle }) => {
	const [showAlert, setShowAlert] = useState(false)
	const [showLoading, setShowLoading] = useState(false)
	const [logs, setLogs] = useState(undefined)
	const [alertType, setAlertType] = useState({ type: "", text: "" })

	const getLogs = () => {
		setShowLoading(true)
		const resource = `whistles/log?whistle_id=${whistle.id}`
		setShowLoading(true)
		APIGet(resource).then(res => {
			setShowLoading(false)
			setLogs(res.data.logs)

		}).catch(err => {
			const error = "couldn't fetch logs - errormessage: " + err.response.data
			setAlertType({ type: "error", text: error })
			setShowAlert(true)
			setShowLoading(false)
		})
	}

	const sortLogsByTs = (logs) => {
		const sortedLogs = logs.sort((a, b) => b.ts-a.ts)
		setLogs(sortedLogs)
	}

	useEffect(() => {
		if(logs === undefined && !whistle.whistle_owner)
			getLogs()

		if(whistle.whistle_owner)
			sortLogsByTs([...whistle.messages, ...whistle.actions])
		// eslint-disable-next-line react-hooks/exhaustive-deps	
	}, [logs])

	if (logs === undefined)
		return (
			<>
				<Loading
					showLoading={showLoading}
					inFront
				/>
				<AlertModal
					isShowing={showAlert}
					setIsShowing={setShowAlert}
					type={alertType.type}
					text={alertType.text}
				/>
			</>
		)

	const cleanedLogs = cleanLogs(logs, whistle.access.screen_name)

	return (<>
		<div className="bg-white rounded-4 p-5 loglist">
			<div className="mb-0 ">
				<div>
					<div className="d-flex flex-rowy primary sibilus_border px-3 bg_light_grey">
						<div className="py-1 col"><T>Timestamp</T></div>
						<div className="py-1 col"><T>Action</T></div>
						<div className="py-1 col"><T>Comment</T></div>
					</div>
					<div className="loglist_content">
						{cleanedLogs.map((log, i) => (
							<Log log={log} key={"log" + i} />
						))}
					</div>
				</div>
			</div>
		</div>
	</>)
}

export default Logs
